"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderItems = exports.HeaderItemButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MenuButton = _interopRequireDefault(require("../Shared/MenuButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeaderItemButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "HeaderMenustyles__HeaderItemButton",
  componentId: "sc-1mzna08-0"
})(["margin-right:17px;padding:7px 0 0;border-bottom:5px solid transparent;&:before{position:absolute;content:'';width:0;height:0;border:7px solid transparent;margin:auto;bottom:-10px;}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){position:relative;&:before{bottom:-15px;left:calc(50% - 6px);}}", " @media (min-width:", "px){margin-right:26px;}"], function (props) {
  return props.isActive && "\n    border-color: ".concat(props.theme.carvana.blue.primary, ";\n    color: ").concat(props.theme.carvana.blue.primary, ";\n    &:before {\n      border-top: 4px solid ").concat(props.theme.carvana.blue.primary, ";\n    }\n  ");
}, function (props) {
  return props.theme.breakpoints.values.md;
});
exports.HeaderItemButton = HeaderItemButton;

var HeaderItems = _styledComponents.default.div.attrs({
  "data-qa": "header-items"
}).withConfig({
  displayName: "HeaderMenustyles__HeaderItems",
  componentId: "sc-1mzna08-1"
})(["flex:1;height:100%;display:flex;"]);

exports.HeaderItems = HeaderItems;